import React from 'react';
import '../../../styles/components/EditBusinessProfile.scss';

const EditBusinessProfile: React.FC = () => {
    return (
        <div className="edit-business-profile">
            <h1>Edit Business Profile</h1>
            <p>Customize your business details, check-in settings, and branding here.</p>
            <form>
                <label>
                    Business Name:
                    <input type="text" placeholder="Enter your business name" />
                </label>
                <label>
                    Business Address:
                    <input type="text" placeholder="Enter your business address" />
                </label>
                <label>
                    Contact Email:
                    <input type="email" placeholder="Enter your contact email" />
                </label>
                <label>
                    Contact Phone:
                    <input type="tel" placeholder="Enter your contact phone" />
                </label>
                <label>
                    Business Description:
                    <textarea placeholder="Enter a brief description of your business"></textarea>
                </label>
                <label>
                    Check-In Questions:
                    <textarea placeholder="Enter custom check-in questions"></textarea>
                </label>
                <label>
                    Branding Color:
                    <input type="color" />
                </label>
                <button type="submit">Save Changes</button>
            </form>
        </div>
    );
};

export default EditBusinessProfile;